import React, { useState } from "react";
import { Auth } from "aws-amplify";

import HideableBox from "../Generic/HideableBox";
import DivButton from "../Generic/DivButton";

export function EditEmail(props) {
  const [email, setEmail] = useState("");
  const [emailToVerify, setVerEmail] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = () => {
    Auth.currentAuthenticatedUser().then((user) => {
      //   console.log(user);
      Auth.updateUserAttributes(user, { email: email })
        .then((data) => {
          console.log(data);
          setMessage(data);
          setVerEmail(email);
        })
        .catch((err) => {
          console.log(err, JSON.stringify(err));

          setMessage(err.message);
        });
    });
  };

  const verify = () => {
    props.signOut();
  };
  return (
    <>
      <div>
        <label htmlFor="email">Email</label>
        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        ></input>
        <DivButton onClick={onSubmit}> Submit</DivButton>
        <div>
          {message === "SUCCESS" ? (
            <>
              <div>{`Successfully changed email to: ${emailToVerify}.`}</div>
              <div>
                <p>
                  Please Verify your email with the code sent to that email
                  address.
                </p>
                <p>
                  You will be prompted to log in again with your new email and
                  password. please double-check the spelling of both before you
                  continue
                </p>
                <DivButton onClick={verify}>Verify</DivButton>
              </div>
            </>
          ) : (
            <div className="error">{message}</div>
          )}
        </div>
      </div>
    </>
  );
}
